import React from "react";
import styled from "styled-components";
import realization1 from "../../assets/serena.png";
import starFilled from "../../assets/solar_star-broken1.png";
import starEmpty from "../../assets/solar_star-broken.png";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      rating: 3,
      text: '"Lorem in real-time where the money is spent,and to lend out th\nI don\'t have',
      author: "Clinique Serena",
      website: "clinicserena.com"
    },
    {
      id: 2,
      rating: 3,
      text: '"Lorem in real-time where the money is spent,and to lend out th\nI don\'t have',
      author: "Clinique Serena",
      website: "clinicserena.com"
    },
    {
      id: 3,
      rating: 3,
      text: '"Lorem in real-time where the money is spent,and to lend out th\nI don\'t have',
      author: "Clinique Serena",
      website: "clinicserena.com"
    }
  ];

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <StarImage 
          key={i}
          src={i < rating ? starFilled : starEmpty} 
          alt="star"
        />
      );
    }
    return stars;
  };

  return (
    <TestimonialsSection>
      <BackgroundCard />
      
      <TestimonialsContainer>
        <Header>
          <HeaderTitle>
            Ils parlent de nous .
          </HeaderTitle>
          <HeaderDescription>
            Découvrez ce que nos clients disent de nous. Cela compte beaucoup pour nous. 
            Que ce soit positif ou négatif, nous en tiendrons compte pour améliorer OlaSoft.
          </HeaderDescription>
        </Header>

        <CardsContainer>
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id}>
              <CardOverlay />
              <CardContent>
                <Stars>
                  {renderStars(testimonial.rating)}
                </Stars>
                <TestimonialText>
                  {testimonial.text}
                </TestimonialText>
              </CardContent>
              <Author>
                <AuthorAvatar>
                  <AvatarImage src={realization1} alt={testimonial.author} />
                </AuthorAvatar>
                <AuthorInfo>
                  <AuthorName>{testimonial.author}</AuthorName>
                  <AuthorWebsite>{testimonial.website}</AuthorWebsite>
                </AuthorInfo>
              </Author>
            </Card>
          ))}
        </CardsContainer>
      </TestimonialsContainer>
    </TestimonialsSection>
  );
};

export default Testimonials;

// Styled Components
const TestimonialsSection = styled.section`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #060622 0%, #161645 100%);
  position: relative;
  overflow: hidden;
  padding: 20vw 6vw 12vw 6vw;
  font-family: Raleway, sans-serif;
  box-sizing: border-box;

  /* Tablet */
  @media (min-width: 768px) {
    padding: 15vw 5vw 10vw 5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    min-height: 50.781vw;
    padding: 12.76vw 5.448vw 8vw 5.448vw;
  }
`;

const BackgroundCard = styled.div`
  display: none;

  /* Desktop */
  @media (min-width: 1024px) {
    display: block;
    width: calc(100% - 10vw);
    max-width: 88.917vw;
    height: 30vw;
    position: absolute;
    top: 7.76vw;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 0.383vw;
    border: 0.056vw solid;
    background: linear-gradient(180deg, #FF3D00 -42.59%, rgba(0, 0, 0, 0) -42.59%, #FF3D00 -42.58%, rgba(255, 61, 0, 0.18) 4.35%, rgba(194, 0, 0, 0.05) 99.99%, rgba(255, 61, 0, 0) 100%);
    border-image: linear-gradient(77.91deg, rgba(255, 61, 0, 0.1375) 1.95%, rgba(255, 61, 0, 0.11) 1.95%, rgba(194, 0, 0, 0.0825) 108.82%);
    border-image-slice: 1;
    z-index: 1;
  }
`;

const TestimonialsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  /* Desktop */
  @media (min-width: 1024px) {
    max-width: 72.917vw;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 10vw;
  position: relative;
  z-index: 10;

  /* Tablet */
  @media (min-width: 768px) {
    margin-bottom: 8vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    margin-bottom: 3.49vw;
  }
`;

const HeaderTitle = styled.h2`
  font-size: 8vw;
  font-weight: 200;
  color: #FFFFFF;
  margin-bottom: 4vw;
  letter-spacing: 0.05em;
  line-height: 1.2;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 5vw;
    margin-bottom: 3vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 2.125vw;
    margin-bottom: 1.563vw;
  }
`;

const HeaderDescription = styled.p`
  font-size: 4vw;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin: 0 auto;
  padding: 0 2vw;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.5vw;
    max-width: 80%;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 1.042vw;
    max-width: 52.083vw;
    padding: 0;
  }
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 6vw;
  position: relative;
  z-index: 2;

  /* Tablet */
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 2.083vw;
  }
`;

const Card = styled.div`
  width: 100%;
  min-height: 60vw;
  border-radius: 3vw;
  border: 0.3vw solid;
  background: linear-gradient(180deg, #FF3D00 -42.59%, rgba(0, 0, 0, 0) -42.59%, #FF543E -42.58%, rgba(255, 84, 62, 0.18) 4.35%, rgba(194, 0, 0, 0.05) 99.99%, rgba(255, 84, 62, 0) 100%);
  border-image: linear-gradient(77.91deg, rgba(255, 61, 0, 0.1375) 1.95%, rgba(255, 61, 0, 0.11) 1.95%, rgba(194, 0, 0, 0.0825) 108.82%);
  border-image-slice: 1;
  backdrop-filter: blur(2vw);
  padding: 6vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-1vw);
  }

  /* Tablet */
  @media (min-width: 768px) {
    min-height: 50vw;
    border-radius: 2vw;
    border: 0.2vw solid;
    padding: 4vw;

    &:hover {
      transform: translateY(-0.8vw);
    }
  }

  /* Desktop */
  @media (min-width: 1024px) {
    max-width: 26.667vw;
    min-height: 15.104vw;
    border-radius: 0.36vw;
    border: 0.04vw solid;
    backdrop-filter: blur(0.595vw);
    padding: 2.083vw;

    &:hover {
      transform: translateY(-0.521vw);
    }
  }
`;

const CardOverlay = styled.div`
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(255, 61, 0, 0.08) 0%, rgba(194, 0, 0, 0.02) 50%, rgba(0, 0, 0, 0.1) 100%);
  pointer-events: none;
  z-index: 0;
`;

const CardContent = styled.div`
  position: relative;
  z-index: 1;
`;

const Stars = styled.div`
  display: flex;
  gap: 2vw;
  margin-bottom: 4vw;

  /* Tablet */
  @media (min-width: 768px) {
    gap: 1.5vw;
    margin-bottom: 3vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    gap: 0.417vw;
    margin-bottom: 1.563vw;
  }
`;

const StarImage = styled.img`
  width: 6vw;
  height: 6vw;

  /* Tablet */
  @media (min-width: 768px) {
    width: 4vw;
    height: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 1.563vw;
    height: 1.563vw;
  }
`;

const TestimonialText = styled.p`
  color: #FFFFFF;
  font-size: 4vw;
  line-height: 1.5;
  margin-bottom: 5vw;
  white-space: pre-line;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.5vw;
    margin-bottom: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 0.938vw;
    margin-bottom: 2.083vw;
  }
`;

const Author = styled.div`
  display: flex;
  align-items: center;
  gap: 3vw;
  margin-top: auto;
  position: relative;
  z-index: 1;

  /* Tablet */
  @media (min-width: 768px) {
    gap: 2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    gap: 0.833vw;
  }
`;

const AuthorAvatar = styled.div`
  width: 12vw;
  height: 12vw;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  /* Tablet */
  @media (min-width: 768px) {
    width: 8vw;
    height: 8vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 3.125vw;
    height: 3.125vw;
  }
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorName = styled.div`
  color: #FFFFFF;
  font-size: 4vw;
  font-weight: 200;
  margin-bottom: 1vw;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 0.938vw;
    margin-bottom: 0.208vw;
  }
`;

const AuthorWebsite = styled.div`
  color: #FF3D00;
  font-size: 3.5vw;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 0.781vw;
  }
`;